import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../../report/data-services/config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'getLanguageName'
})
export class LanguagePipe implements PipeTransform {

    constructor(private configService: ConfigurationService) { }

    public transform(value: string, args?: any): Observable<string> {
        return this.configService.getLanguages().pipe(map(x => x[value] || 'Die gesuchte Sprache kann nicht gefunden werden.'));
    }
}